export default __webpack_public_path__ + "static/media/j-fntes_export.9aa1d318.glb";